<template>
  <div class="full">
    <div class="loadingio-spinner-bean-eater-1ugble6af7t"><div class="ldio-v68cdpwy5z">
  <div><div></div><div></div><div></div></div><div><div></div><div></div><div></div></div>
  </div></div>
  </div>
</template>

<style type="text/css">
.full{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(97, 97, 97, 0.349);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes ldio-v68cdpwy5z-1 {
    0% { transform: rotate(0deg) }
   50% { transform: rotate(-45deg) }
  100% { transform: rotate(0deg) }
}
@keyframes ldio-v68cdpwy5z-2 {
    0% { transform: rotate(180deg) }
   50% { transform: rotate(225deg) }
  100% { transform: rotate(180deg) }
}
.ldio-v68cdpwy5z > div:nth-child(2) {
  transform: translate(-15px,0);
}
.ldio-v68cdpwy5z > div:nth-child(2) div {
  position: absolute;
  top: 42.199999999999996px;
  left: 42.199999999999996px;
  width: 126.6px;
  height: 63.3px;
  border-radius: 126.6px 126.6px 0 0;
  background: #ffe691;
  animation: ldio-v68cdpwy5z-1 1.0204081632653061s linear infinite;
  transform-origin: 63.3px 63.3px
}
.ldio-v68cdpwy5z > div:nth-child(2) div:nth-child(2) {
  animation: ldio-v68cdpwy5z-2 1.0204081632653061s linear infinite
}
.ldio-v68cdpwy5z > div:nth-child(2) div:nth-child(3) {
  transform: rotate(-90deg);
  animation: none;
}@keyframes ldio-v68cdpwy5z-3 {
    0% { transform: translate(200.45px,0); opacity: 0 }
   20% { opacity: 1 }
  100% { transform: translate(73.85px,0); opacity: 1 }
}
.ldio-v68cdpwy5z > div:nth-child(1) {
  display: block;
}
.ldio-v68cdpwy5z > div:nth-child(1) div {
  position: absolute;
  top: 97.05999999999999px;
  left: -8.44px;
  width: 16.88px;
  height: 16.88px;
  border-radius: 50%;
  background: #ffb6bb;
  animation: ldio-v68cdpwy5z-3 1.0204081632653061s linear infinite
}
.ldio-v68cdpwy5z > div:nth-child(1) div:nth-child(1) { animation-delay: -0.6566000000000001s }
.ldio-v68cdpwy5z > div:nth-child(1) div:nth-child(2) { animation-delay: -0.3234s }
.ldio-v68cdpwy5z > div:nth-child(1) div:nth-child(3) { animation-delay: 0s }
.loadingio-spinner-bean-eater-1ugble6af7t {
  width: 211px;
  height: 211px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-v68cdpwy5z {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-v68cdpwy5z div { box-sizing: content-box; }
/* generated by https://loading.io/ */
</style>
